<template>
    <div>
        <p><b>{{ title }}</b></p>

        <ul class="vehicle-meta list-unstyled">
            <li class="make">
                <span>{{ quote.derivative.manufacturerName }}</span>
                {{ quote.derivative.modelName }}
            </li>
            <li class="derivative">
                <span class="key">{{ quote.derivative.derivativeName }}</span>
            </li>
        </ul>

        <div class="row vehicle-stats">
            <div class="col-6">
                <div class="row">
                    <div class="col-6">
                        <span class="key">Contract Term</span>
                        <div class="value">{{ quote.definition.plan.term }}</div>
                    </div>
                    <div class="col-6">
                        <span class="key">Annual Mileage</span>
                        <div class="value">{{ quote.definition.plan.annualDistance }}</div>
                    </div>
                    <div class="col-6" v-if="!fuelTypeElectric(quote.derivative.fuelTypeDescription)">
                        <span class="key">MPG</span>
                        <span class="value">{{ quote.derivedMPG }}</span>
                    </div>
                    <div class="col-6" v-if="fuelTypeElectricOrPluginHybrid(quote.derivative.fuelTypeDescription)">
                        <span class="key">Electric Range</span>
                        <span class="value">{{ this.getTechnicalItem("NEDCMaximumEVRangeMiles") }}</span>
                    </div>
                    <div class="col-6" v-if="fuelTypeElectricOrPluginHybrid(quote.derivative.fuelTypeDescription)">
                        <span class="key">Engine Power</span>
                        <span class="value">{{ this.getTechnicalItem("enginePowerKW") }}kW</span>
                    </div>
                    <div class="col-6">
                        <span class="key">P11d Value</span>
                        <span class="value">£{{ quote.details.pricing.p11DValue }}</span>
                    </div>
                    <div class="col-6">
                        <span class="key">CO2 (Combined)</span>
                        <span class="value">{{ this.getTechnicalItem('CO2gkm') }}g/km</span>
                    </div>
                    <div class="col-6" v-if="!fuelTypeElectricOrPluginHybrid(quote.derivative.fuelTypeDescription)">
                        <span class="key">Engine Size</span>
                        <span class="value">{{ this.getTechnicalItem('CC') }}cc</span>
                    </div>
                    <div class="col-6">
                        <span class="key">Transmission</span>
                        <span class="value"> {{ this.getTechnicalItem('Transmission') }}</span>
                    </div>
                    <div class="col-6">
                        <span class="key">Fuel Type</span>
                        <span class="value">{{ quote.derivative.fuelTypeDescription }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <vehicle-image :derivative="quote.derivative" :showMain="true"/>
            </div>
        </div>
    </div>
</template>

<script>
import VehicleImage from "../vehicle-details/vehicle-image.vue";
import ComparisonAdditional from "../car-comparison/comparison-additional.vue";
import {fuelTypeElectric, fuelTypeElectricOrPluginHybrid} from "@/helpers/fuel-type";

export default {
    name: "vehicle-details",
    components: { VehicleImage, ComparisonAdditional },
    props: ["title", "quote", 'adminPortalData'],
    methods: {
        fuelTypeElectric,
        fuelTypeElectricOrPluginHybrid,
        getTechnicalItem(type) {
            for (let i = 0; i < this.quote.derivative.technicalItems.length; i++) {
                if (type === this.quote.derivative.technicalItems[i].technicalItemName) {
                    return this.quote.derivative.technicalItems[i].technicalItemValue;
                }
            }
        }
    }
};
</script>

<style scoped lang="scss">
.vehicle-meta {
  .make {
    font-size: 20px;
    font-weight: bold;
  }

  .derivative {
    text-transform: uppercase;
    font-size: 12px;
  }
}
.vehicle-stats {
  .key, .value {
    display:block;
  }
  .key {
    font-size: 11px;
    line-height: 13px;
  }
  .value {
    font-size: 17px;
  }
  .col-6 {
    margin-bottom: 15px;
  }
}
</style>
